import React from "react";
import { IconLayoutSidebarRight } from "@tabler/icons-react";
import { Tooltip, TooltipContent, TooltipTrigger } from "@/components/ui/tooltip";
import { cn } from "@/lib/utils";
import * as TooltipPrimitive from "@radix-ui/react-tooltip";

interface ShowDetailsActionProps {
  onClick: () => void;
  className?: string;
}

const ShowDetailsAction: React.FC<ShowDetailsActionProps> = ({ onClick, className }) => {
  return (
    <Tooltip>
      <TooltipTrigger className="z-20" onClick={onClick}>
        <div
          className={cn(
            "z-10 cursor-pointer flex h-[28px] w-[28px] items-center justify-center squircle-mask squircle-radius-[8px] border-[rgba(246,245,245,0.70)] bg-[linear-gradient(97deg,rgba(255,255,255,0.80)_27.6%,rgba(255,255,255,0.80)_100.45%)] shadow-[0_0.7px_1.4px_0_rgba(0,0,0,0.05)] backdrop-blur-[1.6px]",
            className,
          )}
          onClick={onClick}
        >
          <IconLayoutSidebarRight size={14} className="text-black" />
        </div>
      </TooltipTrigger>
      <TooltipPrimitive.Portal>
        <TooltipContent side="bottom" sideOffset={10} align="end">
          <p>Show Details</p>
        </TooltipContent>
      </TooltipPrimitive.Portal>
    </Tooltip>
  );
};

export default ShowDetailsAction;
